import OperationalOverview from '@/features/operational-overview/OperationalOverview';

export default function OverviewView() {
  return <OperationalOverview />;
}